var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTwitterLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.235 10.851 18.7 4.5h-1.295l-4.744 5.515L8.87 4.5H4.5l5.73 8.34L4.5 19.5h1.295l5.01-5.824 4.002 5.824h4.37l-5.942-8.649Zm-1.773 2.062-.581-.83-4.62-6.608h1.99l3.727 5.332.58.83 4.847 6.933h-1.989l-3.954-5.657Z",
  fill: "#142739"
})));
export default SvgTwitterLogo;